<template>
  <div class="video-item">
    <video
      ref="videoStream"
      :src="videoSrc"
      :autoplay="autoplay"
      :muted="muted"
      :controls="controls"
      type="video/*"
      @error="onVideoError"
    ></video>
  </div>
</template>

<script>
export default {
  props: {
    videoSrc: {
      type: String,
      required: true,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    muted: {
      type: Boolean,
      default: true,
    },
    controls: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      video: null,
    };
  },
  mounted() {
    this.video = this.$refs.videoStream;
    const canPlayWebm = this.video.canPlayType("video/webm");

    if (canPlayWebm === "probably" || canPlayWebm === "maybe") {
      this.video.addEventListener("ended", this.onVideoEnded);
    } else {
      alert("Este navegador no admite el tipo MIME video/webm");
      return;
    }
  },
  methods: {
    onVideoEnded(event) {
      this.$emit("onVideoEnded", event);
    },
    onVideoError(event) {
      alert("No se puede reproducir el archivo de video:", event.target.error);
    },
  },
};
</script>

<style>
.video-item {
  margin-bottom: 20px;
}
video {
  width: 100% !important;
  height: auto !important;
}
</style>
